import * as React from "react";
import {graphql, Link, useStaticQuery} from "gatsby";
import {StaticImage} from "gatsby-plugin-image";
import '../../styles/footer.scss';

export default function Footer() {
    const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

    return <div>
        <footer className='footer-section has-text-centered'>
            <div>
                <Link to="/">
                    <StaticImage
                        placeholder="blurred"
                        className='logo'
                        src='../../images/Logo.png'
                        alt='Huguette Bello - logo'/>
                </Link>
            </div>
            <br/>
            <hr/>
            <div className="columns has-text-left">
                <div className="column is-one-third">
                    <h1 className='subtitle has-text-danger'>À propos</h1>
                    <p>La reproduction totale ou partielle du site internet et de son contenu est interdite
                        (Article L. 122-2 du Code de la propriété intellectuelle).</p>
                </div>
                <div className="column is-one-third">
                    <h1 className='subtitle has-text-danger'>Accès rapide</h1>
                    <p><Link to='/mentions-legales'>Mentions legales</Link></p>
                </div>
                <div className="column is-one-third">
                    <h1 className='subtitle has-text-danger'>Réseaux sociaux</h1>
                    <a href='https://www.facebook.com/H.Bello.Reunion'><i style={{color: "#fff", fontSize: "3em", width:"50px"}} className="icone fab fa-facebook"/></a>
                    <a href='https://twitter.com/HuguetteBello'><i style={{color: "#fff", fontSize: "3em", width:"50px"}} className="icone fab fa-twitter"/></a>
                    <a href='https://www.instagram.com/huguettebello'><i style={{color: "#fff", fontSize: "3em", width:"50px"}} className="icone fab fa-instagram"/></a>
                    <a href='https://www.youtube.com/c/HuguetteBello'><i style={{color: "#fff", fontSize: "3em", width:"50px"}} className="icone fab fa-youtube"/></a>
                </div>
            </div>
            <br/>
            <p>
                © {new Date().getFullYear()}, {data.site.siteMetadata?.title}
            </p>
        </footer>
    </div>
}
